import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {Button} from '@betareader/design-system';
import moment from 'moment';

// i18n
import { withTranslation } from 'react-i18next';

// redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  sendInvitationReminder,
  deleteReader
} from '../../../modules/reader';

export class NonStartersList extends Component {
  // lifecycle methods
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.readerEntries.length > 0 && this.props.readerEntries.length === 0) {
      this.props.onClose();
    }
  }

  // custom methods
  sendReminder = (reader) => {
    const {idToken} = this.props;
    this.props.sendInvitationReminder(idToken, reader);
  }

  removeReader = (reader) => {
    const {idToken} = this.props;
    this.props.deleteReader(idToken, reader);
  }

  // rendering
  render() {
    const { readerEntries, t, readOnly } = this.props;
    const threeDaysAgo = new Date();
    threeDaysAgo.setDate(threeDaysAgo.getDate() - 3);
    return (
      <ul style={{listStyle: 'none', margin: 0, padding: 0}}>
        {
          (readerEntries || []).map((reader, index) => {
            const allowReminding = (reader.invitation.remindedAt === undefined || new Date(reader.invitation.remindedAt) < threeDaysAgo);
            return (
              <li key={reader._id} style={{padding: '0.75em 0', borderBottom: '1px solid var(--br-border)'}}>
                <div style={{float: 'right'}}>
                  <div style={{display: 'flex', gap: 8}}>
                    <Button
                      size='small'
                      disabled={!allowReminding || readOnly || reader.updating}
                      aria-busy={reader.updating}
                      onClick={() => {
                        this.sendReminder(reader)
                      }}>
                      {t('SendReminder')}
                    </Button>
                    <Button
                      size='small'
                      variant='danger'
                      disabled={readOnly}
                      onClick={() => {this.removeReader(reader)}}>
                      {t('Remove')}
                    </Button>
                  </div>
                  {
                    !allowReminding &&
                    <div style={{fontSize:'0.8em',maxWidth:150}}>{t('YouCanSendAReminderEvery3Days')}</div>
                  }
                </div>
                <strong>
                  {reader.name}
                </strong>
                <div>
                  <div style={{fontSize:'0.9em'}}>
                    { reader.invitation.requestedAt === undefined &&
                      <span>
                        {t('Created')}: {moment(reader.createdAt).fromNow()}<br/>
                      </span>
                    }
                    { reader.invitation.requestedAt !== undefined &&
                      <span>
                        {t('RequestedToRead')}: {moment(reader.invitation.requestedAt).fromNow()}<br/>
                      </span>
                    }
                    { reader.invitation.sentAt !== undefined &&
                      <span>
                        {t('InvitationSent')}: {moment(reader.invitation.sentAt).fromNow()}<br/>
                      </span>
                    }
                    { reader.invitation.approvedAt !== undefined &&
                      <span>
                        {t('Approved')}: {moment(reader.invitation.approvedAt).fromNow()}<br/>
                      </span>
                    }
                    { reader.invitation.acceptedAt !== undefined &&
                      <span>
                        {t('Accepted')}: {moment(reader.invitation.acceptedAt).fromNow()}<br/>
                      </span>
                    }
                    { reader.invitation.remindedAt !== undefined &&
                      <span>
                        {t('Reminded')} {moment(reader.invitation.remindedAt).fromNow()}<br/>
                      </span>
                    }
                  </div>
                </div>
              </li>
            );
          })
        }
    </ul>
    )

  }
}

// redux stuff
const mapStateToProps = state => ({
  user: state.user.user,
  idToken: state.user.idToken,
  userProfile: state.user.userProfile,
  currentBook: state.book.currentBook,
})

const mapDispatchToProps = dispatch => bindActionCreators({
  sendInvitationReminder,
  deleteReader,
}, dispatch)

export default withTranslation()(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(NonStartersList)));
